module.exports = __webpack_public_path__ + "img/hgqxj.373d1536.jpg";